<template>
  <div>
    <v-combobox
      ref="emailsSelect"
      :label="$t('Contact E-mails')"
      :items="users"
      multiple
      chips
      v-model="emailsSelected"
      @change="saveEmails"
      :success-messages="successEmails"
      :error-messages="errorEmails"
      data-cy="email-entity-select"
    ></v-combobox>
    <v-select
      :label="$t('Language for emails')"
      :items="locales"
      v-model="localeSelected"
      @change="saveLocale"
      :success-messages="successLocale"
      :error-messages="errorLocale"
    ></v-select>
  </div>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";

export default {
  name: "EmailsEntitySelect",
  props: ["entity"],
  mixins: [snackbar],
  data() {
    return {
      emailsSelected: this.entity.contact_emails,
      successEmails: "",
      errorEmails: "",
      successLocale: "",
      errorLocale: "",
      locales: this.$i18n.availableLocalesLabels,
      localeSelected: this.entity.contact_lang,
    };
  },
  computed: {
    ...mapState({
      users: (state) =>
        state.users.items.reduce((acc, x) => {
          acc.push(x.email);
          return acc;
        }, []),
    }),
  },
  created() {
    if (this.users.length === 0) {
      this.$store.dispatch("users/fetchAll");
    }
  },
  methods: {
    saveEmails() {
      this.$store
        .dispatch("entities/saveEmails", {
          entityId: this.entity.id,
          contactEmails: this.emailsSelected,
        })
        .then(() => {
          this.successEmails = this.$t("snackbar-message-email.updated");
          setTimeout(() => (this.successEmails = ""), 5000);
        })
        .catch(() => {
          this.errorEmails = this.$t("snackbar-message-email.error");
          setTimeout(() => (this.errorEmails = ""), 5000);
        });
    },
    saveLocale() {
      this.$store
        .dispatch("entities/saveLocale", {
          entityId: this.entity.id,
          contactLang: this.localeSelected,
        })
        .then(() => {
          this.successLocale = this.$t("snackbar-message-language.updated");
          setTimeout(() => (this.successLocale = ""), 5000);
        })
        .catch(() => {
          this.errorLocale = this.$t("snackbar-message-language.error");
          setTimeout(() => (this.errorLocale = ""), 5000);
        });
    },
  },
};
</script>